// 2023.07.13 New Standard API
// import  _ from 'lodash'
import {$swoole} from './axios.setup'

// getStandards
export const getStandards = async ({params} = {}) => {
  try {
    const url = '/v1/cars'

    const res = await $swoole.get(url, {
      params,
    })

    if (!res) {
      return
    }

    if (res.status === 200) {
      if (res.data.status === 'success') {
        return res.data
      }
      else {
        throw new Error(res.data.message)
      }
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    alert(err.message || err )
  }
}

// getBrandsOfStandards
export const getBrandsOfStandards = async ({params} = {}) => {
  try {
    const url = '/v1/filter-param-brand-new'
    const res = await $swoole.get(url, {
      params,
    })

    if (!res) {
      return
    }

    if (res.status === 200) {
      if (res.data.status === 'success') {
        return res.data.data
      }
      else {
        throw new Error(res.data.message)
      }
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    alert(err.message || err)
  }
}

// getProvincesOfStandard
export const getProvincesOfStandard = async ({params} = {}) => {
  try {
    const url = '/v1/filter-param-province'
    const res = await $swoole.get(url, {
      params,
    })

    if (!res) {
      return
    }

    if (res.status === 200) {
      if (res.data.status === 'success') {
        return res.data.data
      }
      else {
        throw new Error(res.data.message)
      }
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (error) {
    throw new Error(error)
  }
}

// getSubstationOfStandard
export const getSubstationOfStandard = async ({params} = {}) => {
  try {
    const url = '/v1/filter-param-substations'
    const res = await $swoole.get(url, {
      params,
    })

    if (!res) {
      return
    }

    if (res.status === 200) {
      if (res.data.status === 'success') {
        return res.data.data
      }
      else {
        throw new Error(res.data.message)
      }
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    alert(err.message || err)
  }
}

// getStandard
export const getStandard = async ({params} = {}) => {
  try {
    const url = `/v1/car/${params.id}`
    const res = await $swoole.get(url, {
      params,
    })

    if (!res) {
      return
    }

    if (res.status === 200) {
      if (res.data.status === 'success') {
        return res.data
      }
      else {
        throw new Error(res.status)
      }
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    alert(err.message || err)
  }
}

// retrieveStandardReportEquipment
export const retrieveStandardReportEquipment = async ({params}) => {
  try {
    const url = '/v1/car/configurationChecklist'
    const res = await $swoole.get(url, {
      params,
    })

    if (!res) {
      return
    }

    if (res.status === 200) {
      return res.data
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    alert(err.message || err)
  }
}

// getStandardRecommends
// - 2023.08.16
// - get standard recommends
export const getStandardRecommends = async ({params}) => {
  const url = '/v1/likes'
  const res = await $swoole.get(url, {
    params,
  })

  if (!res) {
    return
  }

  if (res.status === 200) {
    if (res.data.status === 'success') {
      return res.data
    }
    else {
      throw new Error(res.status)
    }
  }
  else {
    throw new Error(res.status)
  }
}

// getStandardMileageReport
// - 2023.08.16
// - get standard report mileage
export const getStandardMileageReport = async ({params}) => {
  try {
    const url = '/v1/vehicleInspection/mileage/'
    const res = await $swoole.get(url, {
      params,
    })

    if (res.status == 200){
      return res.data
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    alert(err.message || err || JSON.stringify(err))
  }
}
